import { PageShell, Section } from "./PageShell";
import { useSeo } from "@/lib/useSeo";

export default function Guidelines() {
  useSeo({
    title: "Content & Community Guidelines — NoobSync Ambassadors",
    description: "Posting rules, partnership disclosure requirements, and best practices for NoobSync Brand Ambassadors — the do's, don'ts, and consequences.",
    path: "/guidelines",
  });
  return (
    <PageShell
      kicker="Legal"
      title="Brand Ambassador Guidelines"
      lead="How to represent NoobSync the right way."
    >
      <Section title="Do's">
        <ul className="list-disc space-y-2 pl-5">
          <li>Represent NoobSync positively and professionally across all platforms.</li>
          <li>Use only approved logos, assets, and messaging from the Resources tab.</li>
          <li>
            All promotional content must <strong>clearly disclose the partnership</strong> using
            {" "}<code className="rounded bg-zinc-900 px-1 text-[#A855F7]">#ad</code>,{" "}
            <code className="rounded bg-zinc-900 px-1 text-[#A855F7]">#NoobSyncPartner</code>, or
            &quot;NoobSync Brand Ambassador&quot; visibly within the first line of the caption or
            post — not buried at the end or in a block of unrelated hashtags. This follows global
            best practice (FTC in the US, ASA in the UK, ASCI in India) and applies to every
            ambassador regardless of country.
          </li>
          <li>Engage genuinely with your audience — answer questions about NoobSync honestly.</li>
          <li>Submit only original content for Reel, YouTube, AI marketing video, podcast and blog categories as specified in the points system.</li>
        </ul>
      </Section>
      <Section title="Don'ts">
        <ul className="list-disc space-y-2 pl-5">
          <li>Don&apos;t make false or exaggerated claims about NoobSync products or services.</li>
          <li>Don&apos;t use paid engagement, bots, or fake accounts to inflate referral or content metrics.</li>
          <li>Don&apos;t submit duplicate, reused, or someone else&apos;s content as your own.</li>
          <li>Don&apos;t use NoobSync branding for any personal commercial purpose outside the program.</li>
          <li>Don&apos;t post content that is offensive, discriminatory, or could damage NoobSync&apos;s reputation.</li>
          <li>Don&apos;t share confidential information about NoobSync&apos;s internal operations, products in development, or business strategy.</li>
          <li>Don&apos;t create derivative logos, modified branding, filters, or merchandise using NoobSync&apos;s trademarks or visual identity without prior written approval.</li>
          <li>Don&apos;t claim ownership, authorship, or copyright over any NoobSync-provided assets. These remain NoobSync&apos;s exclusive property, licensed to you solely for promotional use during active program participation.</li>
        </ul>
      </Section>
      <Section title="Consequences of Violation">
        <ul className="list-disc space-y-2 pl-5">
          <li><b>First violation</b> — Warning and point forfeiture for the related submission.</li>
          <li><b>Repeated or serious violation</b> — Removal from the program without reward eligibility.</li>
        </ul>
      </Section>
    </PageShell>
  );
}
